import React from "react";
import { Grid } from "semantic-ui-react";
import { Form, useAuthClaims} from "@redriver/cinnamon";
import { PermissionsTree, UserAreaDropdown } from "../lookups";
import { UserAreasWithOfficeRestriction } from "features/../../../shared/constants/enums";
import { withPermissions } from "features/../../../shared/components/auth";
import {InternalUserAreas} from "../../../constants/enums";
import {Actions, Targets} from "constants/permissions"

const RoleForm = ({ formProps, editMode, userMode, userAreaForUserBeingEdited }) => {
   
  const { userArea } = useAuthClaims();

  return (
  <Form {...formProps}>
    <Grid>
      <Grid.Column width={8}>
        <Form.Input
          field="name"
          label="Name"
          fluid
          required
          readOnly={userMode}
          placeholder="Template Name..."
        />
        <Form.Input
          field="description"
          label="Description"
          fluid
          readOnly={userMode}
          placeholder="Template Description..."
        />
        <UserAreaDropdown
          label="Type"
          field="userArea"
          lookupParams={{
            userType: null,
            userArea: userArea,
          }}
          required
          fluid
          placeholder="Select a type"
          disabled={editMode}
        />                
        <Form.If condition={({ fields}) => UserAreasWithOfficeRestriction.some(x => x === fields.userArea)}>
        <Form.Checkbox
          field="enableOfficeAccess"
          label="Enable Office Access"
        />       
        </Form.If> 
      </Grid.Column>
      <Grid.Column width={8}>
        <PermissionsTree
          field="permissionRefs"
          label="Permissions"
          required
          userArea={formProps.value.userArea} 
        />
      </Grid.Column>
    </Grid>
  </Form>
);
}

export default RoleForm;
